/*jshint esversion: 6 */

import Flickity from 'flickity';
import "flickity/css/flickity.css";

window.Flickity = Flickity;


